var _path, _g, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#338AF3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 85.337h512v113.775H0zM0 312.888h512v113.775H0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M276.563 261.936 256 256l-20.563 5.936-6.855 11.873h54.836z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "m256 226.32-13.709 23.744L256 256l13.709-5.936z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M235.437 261.936h41.126l-6.854-11.872h-27.418z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNi);
export default __webpack_public_path__ + "static/media/NI.829c68f5.svg";
export { ForwardRef as ReactComponent };